import React from "react";
import { Skeleton } from "antd";
import {
  CalendarOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  TeamOutlined,
  CloseCircleOutlined,
  CoffeeOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import type { ReservationStats as Stats } from "../../../../utils/api/reservationsAPI";
import "./ReservationStats.scss";

type Props = {
  stats: Stats | null;
  loading: boolean;
};

const ReservationStats: React.FC<Props> = ({ stats, loading }) => {
  const { t } = useTranslation();

  const tiles = [
    {
      icon: <CalendarOutlined />,
      label: t("Total"),
      value: stats?.total ?? 0,
      color: "#6366f1",
      bg: "#eef2ff",
    },
    {
      icon: <CheckCircleOutlined />,
      label: t("Confirmed"),
      value: stats?.confirmed ?? 0,
      color: "#10b981",
      bg: "#d1fae5",
    },
    {
      icon: <ClockCircleOutlined />,
      label: t("Pending"),
      value: stats?.pending ?? 0,
      color: "#f59e0b",
      bg: "#fef3c7",
    },
    {
      icon: <CoffeeOutlined />,
      label: t("Seated"),
      value: stats?.seated ?? 0,
      color: "#3b82f6",
      bg: "#dbeafe",
    },
    {
      icon: <TeamOutlined />,
      label: t("Guests"),
      value: stats?.totalGuests ?? 0,
      color: "#8b5cf6",
      bg: "#ede9fe",
    },
    {
      icon: <CloseCircleOutlined />,
      label: t("No Show"),
      value: stats?.noShow ?? 0,
      color: "#ef4444",
      bg: "#fee2e2",
    },
  ];

  if (loading) {
    return (
      <div className="res-stats">
        {tiles.map((_, i) => (
          <div key={i} className="res-stats__tile res-stats__tile--skeleton">
            <Skeleton.Avatar active size={36} shape="square" />
            <Skeleton active paragraph={false} title={{ width: 40 }} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="res-stats">
      {tiles.map((tile) => (
        <div key={tile.label} className="res-stats__tile">
          <span
            className="res-stats__icon"
            style={{ color: tile.color, background: tile.bg }}
          >
            {tile.icon}
          </span>
          <div className="res-stats__info">
            <span className="res-stats__value">{tile.value}</span>
            <span className="res-stats__label">{tile.label}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReservationStats;
